"use client";

import { useListingHeal } from "@/components/listing/useListingHeal";

/**
 * Zelfherstel van een dealpagina die de tijdelijke fallback toonde ("Deal niet
 * gevonden" na een backendblip of -rem, 02-11-2026). Zelfde mechaniek als de
 * lijstpagina's: `?_heal=<ts>` (unieke URL, in de middleware `private, no-store`
 * + noindex), na 2, 5 en 12 s, hoogstens 3 keer; daarna blijft de melding staan.
 * `q` en de overige parameters blijven behouden.
 *
 * `degraded` true: op de fallback (plant de pogingen). `degraded` false: op de
 * herstelde pagina, alleen gerenderd als `_heal` in de URL stond; haalt `_heal`
 * weer uit de adresbalk. Een echte misser (`notFound()`) rendert dit nooit.
 */
export const DEAL_HEAL_DELAYS_MS = [2000, 5000, 12000];

export default function DealTransientHeal({ degraded }) {
  useListingHeal(degraded, { delays: DEAL_HEAL_DELAYS_MS });
  return null;
}
